import React from 'react'
import "./menuTemplate.scss"
import CircularMenu from '../../organisms/circularMenu/circularMenu'
import RotationalContent from '../../organisms/rotationContentMenu/rotationalContent'
import RotationalCalendar from 'componets/organisms/rotationalCalendar/rotationalCalendar'
import tramitesImg from '../../../bgImages/tramites.JPG'
import UniversityComunity from 'componets/organisms/universityCommunity/universityComunity'

const MenuTemplate = ({contentData}) =>{
    //Diccionario con las opciones del menú: 
    const [optionPicked, setOptionPicked] = React.useState(0)
    const MenuOptions =
    ["Comunidad universitaria"
        ,"Convocatorias"
        ,"Bienestar universitario"
        ,"Calendario académico" 
        ,"Noticias y eventos" 
        ,"Laboratorios" 
        ,"Trámites y preguntas"
        ,"Programas ofertados"]
    
    return(
        <>
            
            <div className = "menu-template__main-container">
                {!contentData?<p>Un momento, mientras la información se carga</p>:
                <>
                    <CircularMenu setOptionPicked= {setOptionPicked} options = {MenuOptions} textSize={1}/>
                    

                    {MenuOptions[optionPicked] === "Comunidad universitaria"?
                        
                        contentData[optionPicked] !== undefined && <UniversityComunity data = {contentData[optionPicked]} ></UniversityComunity>
                    :   
                    MenuOptions[optionPicked] === "Calendario académico"?
                    <RotationalContent isOnCalendar={true} className={"menu-template__content"} data={contentData[optionPicked]} textSize={2} imgSrc={tramitesImg}/>
                    :
                        <RotationalContent isOnCalendar={false} className={"menu-template__content"} data={contentData[optionPicked]} textSize={2} imgSrc={tramitesImg}/>
                    }
                </>
                }
            </div>
        </>
    )
}

export default MenuTemplate;